import { Component, ViewChild, } from "@angular/core";
import { NgForm } from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { TicketManagementModel } from "@app/models/ticketManagement/TicketManagementModel";
import { TransactionHistoryService } from "@app/services/transactionHistory/transactionHistory.service";
import { Router, ActivatedRoute } from "@angular/router";

@Component({
    selector: 'terminalDetail',
    templateUrl: './terminalDetail.component.html',
})
export class TerminalDetailComponent {
    tempCount: number;
    SkipCount:number;
    pageNumber: number = 1;
    itemPerPage:number = 10
    OutletId:number;
    ticketManagementModel=new TicketManagementModel();
    ticketManagementList=new Array<TicketManagementModel>();
    constructor(private transactionhistoryService: TransactionHistoryService,
        private toastr: ToastrService,private router :Router,
        private route: ActivatedRoute) { }

    ngOnInit() {
        this.route.params.subscribe(params => {
            if (params['OutletId']) {
                this.OutletId = params['OutletId'];
            }
        });
        this.GetTerminalByOutletCode();
    }

    GetTerminalByOutletCode() {

        this.transactionhistoryService.getTerminalByOutletCode(this.OutletId).subscribe(data => {
            this.ticketManagementList = JSON.parse(JSON.stringify(data));
            this.tempCount=this.ticketManagementList.length;
        });
    }
    pageControl(event: number, sortName: string) {
        this.pageNumber = event;
        this.GetTerminalByOutletCode();
      }
}


// WEBPACK FOOTER //
// ./src/app/components/common/help-desk/terminalDetail.component.ts